import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon } from '@assets/icons';

import { Button } from './styled';

interface Props {
  text?: string;
  onClick: () => void;
  disabled?: boolean;
}

const DesktopClearAllFilters = ({
  text = 'Tüm Filtreleri Temizle',
  onClick,
  disabled,
}: Props) => {
  return (
    <Button onClick={onClick} disabled={disabled}>
      <CustomIcon icon={CloseIcon} fontSize={18} paletteColor='BR300' />
      <Typography variant='caption2' color='BR300' weight='Bold'>
        {text}
      </Typography>
    </Button>
  );
};

export default DesktopClearAllFilters;
